import {
    GET_HOME_APPS,
    GET_HOME_APPS_SUCCESS,
    GET_HOME_APPS_ERROR,
    GET_TV_HOME_APPS,
    GET_TV_HOME_APPS_SUCCESS,
    GET_TV_HOME_APPS_ERROR,
    UPDATE_HOME_APPS_COMMUNITY,
    UPDATE_HOME_APPS_COMMUNITY_ERROR,
    UPDATE_HOME_APPS_COMMUNITY_SUCCESS,
    UPDATE_HOME_APPS_RESIDENT,
    UPDATE_HOME_APPS_RESIDENT_ERROR,
    UPDATE_HOME_APPS_RESIDENT_SUCCESS,
    UPDATE_TV_HOME_APPS_COMMUNITY,
    UPDATE_TV_HOME_APPS_COMMUNITY_ERROR,
    UPDATE_TV_HOME_APPS_COMMUNITY_SUCCESS
} from "../constants/homeAppsConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function homeAppsReducer(state = initialState, action) {

    switch (action.type) {
        case GET_HOME_APPS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'SETTINGS',
                'loadingMessage': 'THE HOME APPS ARE BEING LOADED',
                'type': action.type
            });
        case GET_HOME_APPS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_HOME_APPS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'homeAppsData': action.data,
                'type': action.type
            });
        case GET_TV_HOME_APPS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'type': action.type
            });
        case GET_TV_HOME_APPS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_TV_HOME_APPS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'tvHomeAppsData': action.data,
                'type': action.type
            });
        case UPDATE_HOME_APPS_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'SETTINGS',
                'loadingMessage': 'THE HOME APPS ARE BEING UPDATED',
                'type': action.type
            });
        case UPDATE_HOME_APPS_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case UPDATE_HOME_APPS_COMMUNITY_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type
            });
        case UPDATE_HOME_APPS_RESIDENT:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'SETTINGS',
                'loadingMessage': 'THE HOME APPS ARE BEING UPDATED',
                'type': action.type
            });
        case UPDATE_HOME_APPS_RESIDENT_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_HOME_APPS_RESIDENT_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'type': action.type
            });
        case UPDATE_TV_HOME_APPS_COMMUNITY:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'SETTINGS',
                'loadingMessage': 'THE TV HOME APPS ARE UPDATING',
                'type': action.type
            });
        case UPDATE_TV_HOME_APPS_COMMUNITY_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_TV_HOME_APPS_COMMUNITY_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'tvHomeAppsData': action.data,
                'type': action.type
            });
        default:
            return state;
    }
};

export default homeAppsReducer